export default __webpack_public_path__ + "assets/7b1d4bbc8691c4e5332587cee2ab2b2e/01.jpg";